import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';
import Icon from './Icon';

const CheckboxInput = styled.input`
  display: none;

  ~ div {
    svg:nth-child(1) {
      display: none;
    }
    svg:nth-child(2) {
      display: block;
    }
  }

  &:checked ~ div {
    svg:nth-child(1) {
      display: block;
    }
    svg:nth-child(2) {
      display: none;
    }
  }
`;

const Checkbox = ({ disabled, indeterminate, m, size, color, activeColor, inactiveColor, isLoading, ...rest }) => (
  <>
    <CheckboxInput type="checkbox" disabled={disabled} indeterminate={indeterminate} {...rest} />
    {!indeterminate && !disabled && (
      <Div m={m}>
        <Icon d="block" m="0 auto" size={size} color={activeColor} name={isLoading ? 'Loading' : 'CBChecked'} />
        <Icon d="block" m="0 auto" size={size} color={color} name={isLoading ? 'Loading' : 'CBUnchecked'} />
      </Div>
    )}
    {indeterminate && (
      <Icon d="block" m="0 auto" size={size} color={activeColor} name={isLoading ? 'Loading' : 'CBIndetermine'} />
    )}
    {disabled && (
      <Icon d="block" m="0 auto" size={size} color={inactiveColor} name={isLoading ? 'Loading' : 'CBDisabled'} />
    )}
  </>
);

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  m: PropTypesRepo.m,
  size: PropTypesRepo.d,
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  isLoading: PropTypes.bool,
  cursor: PropTypesRepo.cursor,
  color: PropTypes.string,
};

Checkbox.defaultProps = {
  disabled: false,
  indeterminate: false,
  isLoading: false,
  cursor: 'pointer',
  m: '2px',
  color: 'tabSelected',
  size: '18px',
  inactiveColor: 'tabRest',
  activeColor: 'brand500',
};

export default Checkbox;
